import { VIEW_MANAGEMENT } from 'store/types'

function hideProgressBar() {
  return {
    type: VIEW_MANAGEMENT.HIDE_PROGRESS_BAR,
  }
}

export default hideProgressBar
